import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Text from 'src/Components/Text'
import BotHeadColored from 'src/Components/Avatar/BotHeadColored'

import styles from './CTAHeading.module.scss'

const propTypes = {
  className: PropTypes.string
}

const defaultProps = {}

const CTAHeading = ({ className, children, ...restProps }) => (
  <div className={classnames(className, styles.root)} {...restProps}>
    <BotHeadColored className={styles.botHead} />
    <Text element='span' weight='light'>
      {children}
    </Text>
  </div>
)

CTAHeading.propTypes = propTypes
CTAHeading.defaultProps = defaultProps

export default CTAHeading
